"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendTaskViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class SendTaskViewModel extends ActivityViewModel_1.ActivityViewModel {
    constructor(sendTask, processModel) {
        var _a, _b;
        super(sendTask, processModel);
        this.messageName = (_a = sendTask.messageEventDefinition) === null || _a === void 0 ? void 0 : _a.name;
        this.messageId = (_b = sendTask.messageEventDefinition) === null || _b === void 0 ? void 0 : _b.id;
    }
}
exports.SendTaskViewModel = SendTaskViewModel;
//# sourceMappingURL=SendTaskViewModel.js.map